import { ReactElement } from 'react'
import styled from '@emotion/styled'
import { Chip } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { PayoutContractStatus } from '@archax/shared-types'

const ScheduledChip = styled(Chip)(() => ({
  color: '#0070b9',
  backgroundColor: '#ccd6ed',
}))
export function ScheduledStatus(): ReactElement {
  const { t } = useTranslation()
  return <ScheduledChip label={t(`payoutContracts.statuses.SCHEDULED`)} />
}

const ActiveChip = styled(Chip)(() => ({
  color: '#00A96B',
  backgroundColor: '#c9f1e2',
}))
export function ActiveStatus(): ReactElement {
  const { t } = useTranslation()
  return <ActiveChip label={t(`payoutContracts.statuses.ACTIVE`)} />
}

const PausedChip = styled(Chip)(() => ({
  color: '#bc9605',
  backgroundColor: '#fdf1c4',
}))
export function PausedStatus(): ReactElement {
  const { t } = useTranslation()
  return <PausedChip label={t(`payoutContracts.statuses.PAUSED`)} />
}

const FinishedChip = styled(Chip)(() => ({
  color: '#ff2c53',
  backgroundColor: '#fed7dd',
}))
export function FinishedStatus(): ReactElement {
  const { t } = useTranslation()
  return <FinishedChip label={t(`payoutContracts.statuses.FINISHED`)} />
}

export function renderPayoutStatus(status: PayoutContractStatus): ReactElement {
  switch (status) {
    case PayoutContractStatus.SCHEDULED:
      return <ScheduledStatus />
    case PayoutContractStatus.ACTIVE:
      return <ActiveStatus />
    case PayoutContractStatus.PAUSED:
      return <PausedStatus />
    case PayoutContractStatus.FINISHED:
      return <FinishedStatus />
    default:
      return <></>
  }
}
